import Svg, { Path } from "react-native-svg";

import { colors } from "@/constants/colors";

export function CalendarIcon({
  color = colors.black,
  size = 20,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 24 24" width={size}>
      <Path
        clipRule="evenodd"
        d="M8.25 3C8.66421 3 9 3.33579 9 3.75V4.5H15V3.75C15 3.33579 15.3358 3 15.75 3C16.1642 3 16.5 3.33579 16.5 3.75V4.5H18.75C19.9926 4.5 21 5.50736 21 6.75V18.75C21 19.9926 19.9926 21 18.75 21H5.25C4.00736 21 3 19.9926 3 18.75V6.75C3 5.50736 4.00736 4.5 5.25 4.5H7.5V3.75C7.5 3.33579 7.83579 3 8.25 3ZM4.5 9L19.5 9V6.75C19.5 6.33579 19.1642 6 18.75 6H16.5V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5C15.3358 7.5 15 7.16421 15 6.75V6H9V6.75C9 7.16421 8.66421 7.5 8.25 7.5C7.83579 7.5 7.5 7.16421 7.5 6.75V6H5.25C4.83579 6 4.5 6.33579 4.5 6.75V9Z"
        fill={color}
        fillRule="evenodd"
      />
    </Svg>
  );
}
